import { createFileRoute } from "@tanstack/react-router";
import { KbPageView } from "@/features/knowledge-pages/KbPageView";

export const Route = createFileRoute("/kb/share/$token")({
  component: KbShareRoute,
});

function KbShareRoute() {
  const { token } = Route.useParams();
  return <KbPageView mode={{ kind: "share", token }} />;
}
